import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  ReactGA.initialize('G-4D37YW3SJZ'); // analytics Measurement ID
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({ 
    hitType: 'pageview',
    page: path,
    title: document.title 
  });
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

// Track errors
export const trackError = (description, fatal = false) => {
  ReactGA.event({
    category: 'Error',
    action: description,
    label: fatal ? 'Fatal Error' : 'Non-Fatal Error',
    nonInteraction: true
  });
};